// angular
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// service
import { PwjToastService } from '@app/core/shared/services/app-toast.service';
import { shouldSuppressGlobalHttpErrorToast } from '@shared/utils/auth-error.util';

@Injectable()
export class HandleErrorService {
  public errorMessage!: string;

  // dependencies
  private readonly _toast = inject(PwjToastService);

  constructor() {}

  public handleError(err: HttpErrorResponse) {
    if (shouldSuppressGlobalHttpErrorToast(err)) {
      return;
    }

    this._toast.error(this.errorMessage, 'toastMessages.errorTitle');
  }
}
